import lscache from "lscache";

import * as Constant from "@app/Constant.js";

export const getCacheKey = (key) => {
    return key + '-' + Constant.LSCACHE_VERSION;
};
export const getBranchList = (axios, callback) => {
    const key = getCacheKey(Constant.LSCACHE_KEY.BRANCH_LIST);
    const cached = lscache.get(key);
    if (!cached) {
        axios({
            method: "get",
            url: `/api/tas_stat_v4/branch/list`,
            extra: { showToast: false },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    var sortedList = result.data.data.sort((a, b) => {
                        if(a.status < b.status) {
                            return -1;
                        } else if(a.status > b.status) {
                            return 1;
                        } else {
                            if (a.name < b.name) {
                                return -1;
                            } else if (a.name > b.name) {
                                return 1;
                            } else {
                                return 0;
                            }
                        }
                    });
                    sortedList.forEach((b) => {
                        if(b.status == 'terminate') {
                            b.name = '(해지) ' + b.name;
                        }
                    });
                    lscache.set(key, sortedList, Constant.LSCACHE_BASE_EXPIRE_MINUTE);
                    callback(null, sortedList);
                } else {
                    lscache.remove(key);
                    callback("지사 목록을 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                lscache.remove(key);
                callback("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    } else {
        callback(null, cached);
    }
};

export const getServiceAppList = (axios, callback) => {
    const key = getCacheKey(Constant.LSCACHE_KEY.SERVICE_APP_LIST);
    const cached = lscache.get(key);
    if (!cached) {
        axios({
            method: "get",
            url: `/api/app/service/list`,
        })
            .then((result) => {
                if (result.data.code === 200) {
                    const list = result.data.serviceAppList;
                    lscache.set(key, list, 7 * 24 * 60);
                    callback(null, list);
                } else {
                    lscache.remove(key);
                    callback("서비스 앱 목록을 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                lscache.remove(key);
                callback("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    } else {
        callback(null, cached);
    }
};

export const getAppAuthTypeList = (axios, callback) => {
    const key = getCacheKey(Constant.LSCACHE_KEY.APP_AUTH_TYPE_LIST);
    const cached = lscache.get(key);
    if (!cached) {
        axios({
            method: "get",
            url: `/api/contract/app-auth-type`,
        })
            .then((result) => {
                if (result.data.code === 200) {
                    const list = result.data.appAuthTypeList;
                    lscache.set(key, list, 15 * 24 * 60); // 15일간 보관
                    callback(null, list);
                } else {
                    lscache.remove(key);
                    callback("서비스 계약 타입을 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                lscache.remove(key);
                callback("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    } else {
        callback(null, cached);
    }
};

export const getServiceAppInfo = (appId, serviceAppList) => {
    const key = getCacheKey(Constant.LSCACHE_KEY.SERVICE_APP_LIST);
    if(!serviceAppList) {
        serviceAppList = lscache.get(key);
    }
    
    return serviceAppList.find((sa) => sa.key == appId);
};

export const getSeasonInfo = (axios, callback) => {
    const key = getCacheKey(Constant.LSCACHE_KEY.SEASON_INFO);
    const cached = lscache.get(key);
    if (!cached) {
        axios({
            method: "get",
            url: `/api/contract/season_info`,
        })
            .then((result) => {
                if (result.data.code === 200) {
                    const list = result.data.data;
                    lscache.set(key, list, Constant.LSCACHE_BASE_EXPIRE_MINUTE);
                    callback(null, list);
                } else {
                    lscache.remove(key);
                    callback("계약 시즌 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                lscache.remove(key);
                callback("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    } else {
        callback(null, cached);
    }
};

export const getLocCodes = (axios, callback) => {
    const key = getCacheKey(Constant.LSCACHE_KEY.LOC_CODES);
    const cached = lscache.get(key);
    if (!cached) {
        axios({
            method: "get",
            url: `/api/code/loc`,
        })
            .then((result) => {
                if (result.data.code === 200) {
                    const list = result.data.codes;
                    lscache.set(key, list, 60 * 24 * 7);
                    callback(null, list);
                } else {
                    lscache.remove(key);
                    callback("계약 시즌 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                lscache.remove(key);
                callback("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    } else {
        callback(null, cached);
    }
};
